export enum LocalStorageKeys {
  WALLET_ADDRESS = 'WALLET_ADDRESS',
  STARK_PUBLIC_KEY = 'STARK_PUBLIC_KEY',
  PROVIDER_PREFERENCE = 'PROVIDER_PREFERENCE',
  ETH_NETWORK = 'ETH_NETWORK',
}
